/**
 * GA4 events on every front-end page.
 *
 * - Events the server queued (sign-ups, logins, checkout, purchases,
 *   enrollments) wait in a cookie (Analytics\Event_Queue); they are sent
 *   and the cookie deleted.
 * - A form Elementor sent counts as generate_lead, the newsletter as
 *   newsletter_signup, with the form's name. Elementor's V3 form announces
 *   success with a jQuery event; the V4 form announces nothing and only
 *   takes the class form-state-success.
 */
import { sendQueued } from './analytics/queue.js';
import { track } from './analytics/track.js';

// Forms whose sending is not a lead, by form name.
const FORM_EVENTS = {
	Newsletter: 'newsletter_signup',
};

sendQueued();

window.jQuery?.( document ).on( 'submit_success', ( event ) => {
	formSent( event.target.getAttribute( 'name' ) );
} );

// V4 forms already showing success. Elementor swaps the state classes in
// two steps, so one success brings more than one mutation.
const succeeded = new WeakSet();

new window.MutationObserver( ( mutations ) => {
	mutations.forEach( ( { target } ) => {
		if ( ! target.classList.contains( 'form-state-success' ) ) {
			succeeded.delete( target );
		} else if ( ! succeeded.has( target ) ) {
			succeeded.add( target );
			formSent( target.dataset.formName );
		}
	} );
} ).observe( document.body, {
	subtree: true,
	attributeFilter: [ 'class' ],
} );

/**
 * @param {?string} formName The form's name, as set in Elementor.
 */
function formSent( formName ) {
	// One name holds a <br> for the layout.
	const name = ( formName || '' )
		.replace( /<[^>]*>/g, ' ' )
		.replace( /\s+/g, ' ' )
		.trim();

	track( FORM_EVENTS[ name ] || 'generate_lead', { form_name: name } );
}
